import { useEffect } from 'react';
import { useModal } from '@pcmp/react-providers';
import { useNavigate } from 'react-router-dom';

import { ContactSider } from '@/components/siders/contact';

function ContactPage() {
  const navigate = useNavigate();
  const { openModal } = useModal();

  useEffect(() => {
    navigate('/');

    openModal({
      component: ContactSider,
      props: {},
    });
  }, [navigate, openModal]);

  return null;
}

export default ContactPage;
